// src/context/ClientContext.mjs
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { setClientData, getClientId, getClientName, clearClientData } from '../utils/clientStorage.mjs';

const ClientContext = createContext();

export const useClient = () => {
    const context = useContext(ClientContext);
    if (!context) {
        throw new Error('useClient deve ser usado dentro de ClientProvider');
    }
    return context;
};

export const ClientProvider = ({ children, clientName }) => {
    const [client, setClient] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const validateClient = async () => {
            try {
                setIsLoading(true);
                setError(null);
                
                const baseUrl = process.env.REACT_APP_BASE_URL || 'https://api.eigor.com.br/core';
                const response = await axios.get(`${baseUrl}/clientes`);
                const foundClient = response.data.find(c => 
                    c.nome.toLowerCase() === clientName.toLowerCase()
                );
                
                if (foundClient && foundClient.status) {
                    const clientData = {
                        id: foundClient.id,
                        nome: foundClient.nome,
                        acessosid: foundClient.acessosid
                    };
                    setClient(clientData);
                    // Armazena o ID e nome do cliente no localStorage
                    setClientData(foundClient.id, foundClient.nome);
                } else {
                    setError('Cliente não encontrado ou inativo');
                }
            } catch (err) {
                setError('Erro ao validar cliente');
                console.error('Erro ao validar cliente:', err);
            } finally {
                setIsLoading(false);
            }
        };

        if (clientName) {
            validateClient();
        }
    }, [clientName]);

    const value = {
        client,
        isLoading,
        error,
        clientName
    };

    return (
        <ClientContext.Provider value={value}>
            {children}
        </ClientContext.Provider>
    );
};
